import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import { ReportLocalGovernmentFundsTableFundOwnerForLocalGovernmentModel } from '@/features/mold/models';

export const fetchLocalGovernmentFundIndividualReport = async (id: string) => {
  const localGovernmentFundIndividualReport = await axiosGet(
    `/api/projects/${id}/local-government-fund-individual-report/`,
  );

  return ReportLocalGovernmentFundsTableFundOwnerForLocalGovernmentModel.parse(
    localGovernmentFundIndividualReport,
  );
};

export const useLocalGovernmentFundIndividualReport = (id: string) => {
  return useQuery({
    queryKey: ['localGovernmentFundIndividualReport', id],
    queryFn: async () => {
      return await fetchLocalGovernmentFundIndividualReport(id);
    },
    enabled: !!id,
  });
};
